import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2020-12-07T14:00",
		title: `
<h4>三条市地域包括ケア総合推進センターより</h4>
<p class="paragraph-indent">
●<a 
href="http://www.sanjo-med.or.jp/news/%e4%bb%a4%e5%92%8c%ef%bc%92%e5%b9%b4%e5%ba%a6%e3%80%8c%e6%84%8f%e6%80%9d%e6%b1%ba%e5%ae%9a%e6%94%af%e6%8f%b4%e3%81%ab%e9%96%a2%e3%81%99%e3%82%8b%e5%8b%89%e5%bc%b7%e4%bc%9a%e3%80%8d%e3%81%ae%e3%81%94/"
>令和２年度「意思決定支援に関する勉強会」のご案内</a><br>
<em>参加対象：</em>三条市内介護支援専門員及び地域包括支援センター職員<br>
</p>
<p class="paragraph-indent">
●令和2年度「三条ひめさゆりネット」操作説明会、後方支援病院についての<br data-mq="pc">説明会開催<br>
<em>参加対象：</em>三条ひめさゆりネット導入事業所等<br>
・<a href="${topicsDir}/2020/12-sanjo_sousasetsumeikai_moushikomi-r2.pdf">操作説明会ご案内</a><br>
・<a href="${topicsDir}/2020/12-sanjo_sousasetsumeikai_youryo-r2.pdf">操作説明会開催要項</a><br>
・<a href="${topicsDir}/2020/12-sanjo_ictkouhoushien.pdf">後方支援病院についての説明会のご案内</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2020-12-07T15:00",
		title: `
<h4>南魚沼地域在宅医療推進センターより</h4>
<p class="paragraph-indent">
●<a href="${topicsDir}/2020/12-minamiuonuma_seminar-no6.pdf">2020年度 第６回 月１セミナー「終末期患者の救急搬送について」開催のご案内</a><br>
南魚沼地域以外の県内関係者の参加も可能です。担当者までお問い合わせ下さい。
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2020-12-07T16:00",
		title: `
<h4>村上地域在宅医療推進センターより</h4>
<p class="paragraph-indent">
●11月29日に在宅医療普及講演会を開催しました。<br>
第2部講演はZoomによる映像配信となりましたが、会場には村上市、関川村、粟島浦村から約100名の住民が参集しました。<br>
<a href="${topicsDir}/2020/12-murakami_juuminkeihatsu-r2.pdf">在宅医療普及講演会のご案内</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
